var exports = {
  "Qs": "ExternalLinkWarningModal.module__content___aHpyMW",
  "zc": "ExternalLinkWarningModal.module__iconContainer___aHpyMW",
  "kJ": "ExternalLinkWarningModal.module__iconCircle___aHpyMW",
  "QW": "ExternalLinkWarningModal.module__warningIcon___aHpyMW",
  "FS": "ExternalLinkWarningModal.module__textContainer___aHpyMW",
  "DD": "ExternalLinkWarningModal.module__title___aHpyMW",
  "h_": "ExternalLinkWarningModal.module__description___aHpyMW",
  "VU": "ExternalLinkWarningModal.module__urlSection___aHpyMW",
  "A7": "ExternalLinkWarningModal.module__urlLabel___aHpyMW",
  "vQ": "ExternalLinkWarningModal.module__urlBox___aHpyMW",
  "xG": "ExternalLinkWarningModal.module__urlText___aHpyMW",
  "mH": "ExternalLinkWarningModal.module__checkboxLabel___aHpyMW",
  "x6": "ExternalLinkWarningModal.module__button___aHpyMW",
};

module.exports = exports;
